import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * MyHomeCloud使用エラー表示
 */
class ActivationErrorAlert extends Dialog {
  /**
  * コンストラクタ
  * @param message
  */
  constructor(message: string) {
    super(false);

    // ヘッダーの閉じるボタン
    this.showHeaderCloseButton = false;

    // ダイアログのコンテンツ生成
    let id: string = 'activationErrorDialog';
    let elBody: string = '';

    // ボディ生成
    elBody += '<div class="dialogBody">\n';
    elBody += '<p>\n';
    elBody += message;
    elBody += '</p>';
    elBody += '</div>';

    let footer: string = '<button id="btnCloseWebCAD" value="1"><span class="jp">閉じる</span><span class="en">Close</span></button>';
    this.createDialog(id, '', elBody, footer);

    // イベント設定
    document.getElementById('btnCloseWebCAD').onclick = this.onCloseBtnClicked;

    // お掃除
    id = null;
    elBody = null;
    footer = null;
  }

    /**
     * 閉じるボタンがクリックされた
     */
    onCloseBtnClicked = (e: MouseEvent) => {
      e.preventDefault();

      // サイト側へ遷移
      const { webcad2Dmanager } = marietta.webcad.WebCADGlobal;
      // ページ更新確認ダイアログを一時的に解除
      window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
      // 操作後、保存済みの場合は一覧へ戻す
      // eslint-disable-next-line no-restricted-globals
      location.href = webcad2Dmanager.saved_url;
    }
}

export default ActivationErrorAlert;
